export class SnapshotSubscriptions {
    #subscribers = new Set();
    subscribe(snapshot, selector, listener, equal) {
        const subscriber = {
            select: selector,
            notify: listener,
            equal: equal,
            selected: selector(snapshot),
        };
        this.#subscribers.add(subscriber);
        return () => this.#subscribers.delete(subscriber);
    }
    publish(snapshot) {
        for (const subscriber of this.#subscribers) {
            const selected = subscriber.select(snapshot);
            if (subscriber.equal(selected, subscriber.selected))
                continue;
            subscriber.selected = selected;
            try {
                subscriber.notify(selected);
            }
            catch {
                // Observer failures are isolated from committed simulation state.
            }
        }
    }
}
//# sourceMappingURL=subscriptions.js.map